module.exports = __webpack_public_path__ + "img/card.6d44aa26.jpg";